import DialogService from '../../../../services/dialog-service';
import { GlycemicQuestion } from './glycemic-types';

type ActionFn = (answer: Answer) => void

export enum Answer {
  YES = 'S',
  NO = 'N',
  BOTH = 'A'
}

export default class GlycemicQuestionService {

  questions: GlycemicQuestion[];
  _currentQuest: number;
  _currentAnswer!: Answer;
  _allAnswer: string;
  onComplete: (answers: string, lastQuestionObj: GlycemicQuestion, lastQuestion?: Answer) => void;

  constructor(questions: GlycemicQuestion[], onComplete: (answers: string, lastQuestionObj: GlycemicQuestion, lastQuestion?: Answer) => void) {
    this.questions = questions;
    this._currentQuest = 0;
    this._allAnswer = '';
    this.onComplete = onComplete;
  }

  start(): void {
    const question = this.questions[this._currentQuest];
    if (!question) {
      this.onComplete(this._allAnswer, question);
      return;
    }
    this.openDialog(question.questionDescription, this.handlerAnswer, question.orientationDescription);
  }

  private handlerAnswer(answer: Answer): void {
    const question = this.questions[this._currentQuest];
    this._currentAnswer = answer;

    this._allAnswer = this._allAnswer + question.questionSequence + answer + ';';

    const isExpected = this.isExpected();
    if (isExpected) {
      this.next();
      return;
    }

    this.onComplete(this._allAnswer, question, answer);
  }

  private next(): void {
    if (!this.isPreviousExpected()) {
      this._currentQuest++;
    }

    this._currentQuest++;
    this.start();
  }

  private isExpected(): boolean {
    const question = this.questions[this._currentQuest];
    return question.isAnswer === Answer.BOTH || question.isAnswer === this._currentAnswer;
  }

  private isPreviousExpected(): boolean {
    const question = this.questions[this._currentQuest + 1];
    if (!question) {
      return true;
    }

    return question.isPreviousAnswer === Answer.BOTH || question.isPreviousAnswer === this._currentAnswer;
  }

  private openDialog(message: string, onAnswer: ActionFn, orientacao?: string): void {
    DialogService.open({
      descriptionDialog: orientacao,
      onClickCancel: onAnswer.bind(this, Answer.NO),
      onClickOk: onAnswer.bind(this, Answer.YES),
      titleDialog: message,
      titleOnCancel: 'label.status-no',
      titleOnOk: 'tws.emar.button-yes',
    });
  }
}
